// Reducers specify how the application’s state changes in response to actions sent to the store.
// Remember that actions only describe what happened, but don’t describe how the application’s state changes.

import pageReducer from "./page-reducer";
import navReducer from "./nav-reducer";

// Can also name each of these to another name, eg
// page: pageReducer
const rootReducer = (state = {}, action) => ({
  pageReducer: pageReducer(state.pageReducer, action),
  navReducer: navReducer(state.navReducer, action),
});

export default rootReducer;
